import api from "../../api/api";

// delete module
export const deletePptModule = async (moduleid) =>
  await api.delete(`deleteModule/${moduleid}`);

//update module
export const updatePptModule = async (data) =>
  await api.put(`updateModule/`, data);

//create module
export const createPptModule = async (data) =>
  await api.post(`createNewModule`, data);

//create subModule
export const createPptSubModule = async (data) =>
  await api.post(`createNewSubmodule`, data);
//update subModules
export const updatePptSubModule = async (data) =>
  await api.put(`updateSubModule`, data);
//delete subModules
export const deletePptSubModule = async (submoduleid) =>
  await api.delete(`deleteSubModule/${submoduleid}`);

//create Topic
export const createPptTopic = async (data) =>
  await api.post(`createNewTopic`, data);
//update Topic
export const updatePptTopic = async (data) =>
  await api.put(`updateTopic/`, data);
//delete Topic
export const deletePptTopic = async (topicid) =>
  await api.delete(`deleteTopic/${topicid}`);
